import { useEffect } from 'react';

import FormTitle from 'components/PageLayout/FormTitle';
import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';
import useGoogleAnalytics from 'hooks/useGoogleAnalytics';

import styles from './EndPages.module.scss';

const PAGE_TITLE = 'Thank you for your application';
const PAGE_DESCRIPTION = (
  <p className={styles.descriptionWrapper}>
    Unfortunately, based on the information provided, we do not have any pre-qualified loan offers
    available for you at this time. Please see your email for more details.
  </p>
);

const ApplicationIsNotApprovedNOAA = () => {
  const trackEvent = useGoogleAnalytics();

  useEffect(() => {
    trackEvent(GoogleAnalyticsEventType.ApplyProcessDecline);
  }, []);

  return <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />;
};

export default ApplicationIsNotApprovedNOAA;
